var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"guazi_video",attrs:{"id":"guazi_video"}},[_c('router-view',{ref:"container"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }